export default __webpack_public_path__ + "6d7242c0b10c9babcfeb7558bd8d8bee.png";